import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { TradeAdminRoutingModule } from '../../tradeAdmin-routing.module';
import { EnitComplainceRoutingModule } from '../../eComplaince-routing.module'
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SharedModule } from '../../../../shared/shared.module'
import { CtclModule } from '../../EnitTrade/ctcl/ctcl.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';

//     <=========== Complaince Modules Below ===========>

//import { PreviousQuarterMlaiListComponent } from './EnitCompliance/previous-quarter-mlai-list/previous-quarter-mlai-list.component';



// import {CyberSecurityAdminListComponent} from './EnitCompliance/cyber-security-admin-list/cyber-security-admin-list.component'

import { AgGridModule } from 'ag-grid-angular';

//P2P


//Cyber & System


//import { ShareHoldingCorporateComponentComponent } from './EnitCompliance/share-holding-corporate-component/share-holding-corporate-component.component';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { HighchartsChartModule } from 'highcharts-angular';
import { AnnualReturnsReportComponent } from './annual-returns-report/annual-returns-report.component';
import { CyberIncidentReportComponent } from './cyber-incident-report/cyber-incident-report.component';
import { GlobalAccessReportComponent } from './global-access-report/global-access-report.component';
import { HalfYearlyNetworthReportComponent } from './half-yearly-networth-report/half-yearly-networth-report.component';
import { MlaiPenaltyReportComponent } from './mlai-penalty-report/mlai-penalty-report.component';
import { PenaltyAdjustmentComponent } from './penalty-adjustment/penalty-adjustment.component';
import { PenaltyCalculationDashboardComponent } from './penalty-calculation-dashboard/penalty-calculation-dashboard.component';
import { PenaltySetupComponent } from './penalty-setup/penalty-setup.component';
import { PenaltyCyberAudit } from './CyberAudit/penalty-cyber-audit';
import { PenaltySystemAudit } from './SystemAudit/penalty-system-audit';

@NgModule({
  declarations: [
    AnnualReturnsReportComponent,
    CyberIncidentReportComponent,
    GlobalAccessReportComponent,
    HalfYearlyNetworthReportComponent,
    MlaiPenaltyReportComponent,
    PenaltyAdjustmentComponent,
    PenaltyCalculationDashboardComponent,
    PenaltySetupComponent,




  ],
  imports: [
    
    CommonModule,
    TradeAdminRoutingModule,
    FormsModule,
    DataTablesModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    BsDatepickerModule,
    SharedModule,
    CtclModule,
    EnitComplainceRoutingModule,
    AgGridModule,
    BaseChartDirective,
    HighchartsChartModule,
    PenaltyCyberAudit,
    PenaltySystemAudit,
    NgxChartsModule,
  ]
})
export class PenaltyCalculation { }
